// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font.css';
import axios from 'axios'
//请求列表
import parms from '@/public/parms.js'
//请求方法
import requests from '@/public/requests.js'
//缓存方法
import cache from '@/public/cache.js'
Vue.prototype.parms = parms;
Vue.prototype.requests = requests;
Vue.prototype.$axios = axios;
Vue.prototype.cache = cache;
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
var win = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export default win;



// WEBPACK FOOTER //
// ./src/main.js